import SharedCustomersWidgets from "../classes/SharedCustomersWidgets";
import g_store from "../index";

const defaultState = () => ({
  data: [],
  filter_string: "",
  count_selected: 0
});

const state = defaultState();

// getters
const getters = {
  widgets: store => amo_uuid => {
    let count = 0;
    g_store.commit("shared_customers_widgets_list/setCountSelected", count);
    let data = state.data.filter(v => {
      let r = true;
      if (amo_uuid) {
        try {
          r = v.sharedAmocrm_uuid === amo_uuid;
        } catch (e) {
          r = false;
        }
      }
      !r ||
        (r =
          r &&
          (!state.filter_string ||
            v.beShownForFilterString(state.filter_string)));
      r || (v._selected = false);
      !v._selected || count++;
      return r;
    });
    g_store.commit("shared_customers_widgets_list/setCountSelected", count);
    return data;
  }
};

// actions
const actions = {
  getData(state, variables = {}) {
    return state.rootState.api.query({
      query: require("../../graphql/widgets_amo/shared_customers_widgets_list.graphql"),
      variables: variables
    });
  },
  shared_customers_widgets_list(state, data) {
    state.commit("setData", JSON.parse(JSON.stringify(data)));
  },
  linkSelectedWidgetsWithVendor(state, data) {
    state.rootState.api.mutate({
      mutation: require("../../graphql/widgets_amo/shared_customers_widgets_mutation.graphql"),
      variables: data
    });
  }
};

// mutations
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  setData(state, data) {
    state.data = SharedCustomersWidgets.getSelfList(data);
  },
  setCountSelected(state, count) {
    state.count_selected = count;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
